/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerThemeTokens
 */
export interface PartnerThemeTokens {
    /**
     * 
     * @type {string}
     * @memberof PartnerThemeTokens
     */
    primary?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerThemeTokens
     */
    secondary?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerThemeTokens
     */
    background?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerThemeTokens
     */
    surface?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerThemeTokens
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerThemeTokens
     */
    textMuted?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerThemeTokens
     */
    accent?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerThemeTokens
     */
    radius?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerThemeTokens
     */
    fontFamily?: string;
}

/**
 * Check if a given object implements the PartnerThemeTokens interface.
 */
export function instanceOfPartnerThemeTokens(value: object): value is PartnerThemeTokens {
    return true;
}

export function PartnerThemeTokensFromJSON(json: any): PartnerThemeTokens {
    return PartnerThemeTokensFromJSONTyped(json, false);
}

export function PartnerThemeTokensFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerThemeTokens {
    if (json == null) {
        return json;
    }
    return {
        
        'primary': json['primary'] == null ? undefined : json['primary'],
        'secondary': json['secondary'] == null ? undefined : json['secondary'],
        'background': json['background'] == null ? undefined : json['background'],
        'surface': json['surface'] == null ? undefined : json['surface'],
        'text': json['text'] == null ? undefined : json['text'],
        'textMuted': json['textMuted'] == null ? undefined : json['textMuted'],
        'accent': json['accent'] == null ? undefined : json['accent'],
        'radius': json['radius'] == null ? undefined : json['radius'],
        'fontFamily': json['fontFamily'] == null ? undefined : json['fontFamily'],
    };
}

export function PartnerThemeTokensToJSON(json: any): PartnerThemeTokens {
    return PartnerThemeTokensToJSONTyped(json, false);
}

export function PartnerThemeTokensToJSONTyped(value?: PartnerThemeTokens | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primary': value['primary'],
        'secondary': value['secondary'],
        'background': value['background'],
        'surface': value['surface'],
        'text': value['text'],
        'textMuted': value['textMuted'],
        'accent': value['accent'],
        'radius': value['radius'],
        'fontFamily': value['fontFamily'],
    };
}

